import { ReactNode } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Container from '@mui/material/Container';
import { SideMenu } from './side-menu';
import { TopBar } from './top-bar';
import { useDrawerToggle } from './drawer-hook';

type Props = {
  children: ReactNode;
};

const MainLayout = ({ children }: Props) => {
  const { drawerOpen, isPinnedOpen, pinDrawer, closeDrawer, handleHoverChange } = useDrawerToggle();

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />

      <TopBar drawerOpen={drawerOpen} toggleDrawer={pinDrawer} />

      <SideMenu open={drawerOpen} isPinnedOpen={isPinnedOpen} onPin={pinDrawer} onClose={closeDrawer} onHoverChange={handleHoverChange} />

      <Box
        component="main"
        sx={{
          backgroundColor: (theme) => (theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[900]),
          flexGrow: 1,
          height: '100vh',
          overflow: 'auto',
        }}
      >
        <Toolbar />
        <Container maxWidth={false} sx={{ mt: 2, mb: 2 }}>
          {children}
        </Container>
      </Box>
    </Box>
  );
};

export default MainLayout;
